export const getGlobal = (): any => {
  if (typeof globalThis === 'object') {
    return globalThis;
  }

  if (typeof globalThis.window === 'object') {
    return globalThis.window;
  }

  if (typeof globalThis.global === 'object') {
    return globalThis.global;
  }

  return {};
};
